"use client"

import IconFont from "@repo/ui/iconfont"
import { useSigninModal } from "@repo/ui/signin"
import { useResponsive } from "ahooks"
import Tooltip from "antd/es/tooltip"

import Style from "./index.module.scss"

export default function LockIcon() {
	const { showSignInModal } = useSigninModal()
	const responsive = useResponsive()
	return (
		<Tooltip title="Sign in to view">
			<IconFont
				type="icon-suo"
				style={{ fontSize: 22 }}
				className={Style.lock}
				onClick={() => {
					showSignInModal({
						action: "login",
						animate: responsive.md ? "modal" : "drawer",
						onLoginSuccess: () => {
							window.location.reload()
						},
						onRegisterSuccess: () => {
							window.location.reload()
						},
					})
				}}
			/>
		</Tooltip>
	)
}
